import type { ISensorPoints } from '@model/equipmentDetails';

export const getNodeSensors = (sensorsArr?: Array<ISensorPoints>) => {
  if (!sensorsArr?.length) return [];

  const resArr = Array(6).fill(null);

  sensorsArr.forEach((item) => {
    const sensorPosition = item.sensor?.position || item.position;
    resArr[sensorPosition - 1] = item;
  });

  return resArr;
};
